// Remembers which session this browser belongs to.
// It lives in localStorage (not sessionStorage) so a guest who closes the tab by mistake - or opens the site in a
// second tab - comes back to the same session, and with it to any game that is still running.
const KEY = "sessionId";

export const getStoredSessionId = () => {
    try {
        return localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
    } catch (e) {
        return null;
    }
};

export const storeSessionId = (sessionId) => {
    try {
        localStorage.setItem(KEY, sessionId);
        sessionStorage.removeItem(KEY);
    } catch (e) {
        // Storage can be blocked (private mode etc.) - the session then simply lasts as long as the tab
    }
};

export const clearStoredSessionId = () => {
    try {
        localStorage.removeItem(KEY);
        sessionStorage.removeItem(KEY);
    } catch (e) {
        // ignore
    }
};
